// DS: i3.14
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Search: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M19 11a8 8 0 10-3.095 6.32l3.63 3.63.095.083a1 1 0 001.32-1.498l-3.63-3.63A7.965 7.965 0 0019 11zM5 11a6 6 0 1112 0 6 6 0 01-12 0z" />
    </svg>
  </IconWrap>
);
Search.displayName = 'Search';

export default Search;
